module.exports = __webpack_public_path__ + "static/media/notification.8e7ed10a.mp3";